import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Batiment} from "../Models/Batiment";
import {AppComponent} from "../app.component";
import {cloneDeep, forEach} from "lodash";
import {environment} from 'src/environments/environment';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {EmailRegex, PhoneFrRegex} from "../const/utils";
import {User} from "../Models/User";
import {Agency} from "../Models/Agency";
import {Adresse} from "../Models/Adresse";

@Component({
	selector: 'app-inscription',
	templateUrl: './inscription.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./inscription.component.less'],
})
export class InscriptionComponent implements OnInit {
	textes: any = "";
	globalTxt: any = "";
	submitted = false;
	userForm!: FormGroup;
	userId: any = localStorage.getItem('user_id');
	userRole: any = localStorage.getItem('user_role');
	form_created: boolean = false;
	showMessageIfEmailExist: boolean = false;
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	cguOk: boolean = false;

	constructor(public app: AppComponent, private formBuilder: FormBuilder,) {
	}

	get f() {
		return this.userForm.controls;
	}

	ngOnInit(): void {
		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get Settings
		this.app.sharedToolsService.getSettings();

		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the texts
			this.app.sharedToolsService.loadTexts(_nameJson)
				.subscribe(textes => {
					this.textes = textes;
					console.log("this.textes ==> ", this.textes);
				});
		});
	}
}
